import React from "react";
import ReactDOM from "react-dom";
import "react-awesome-lightbox/build/style.css";
import "./css/variable.css";
import "./index.css";
import AppWrapper from "./AppWrapper";
import App from "./App";
import ErrorBoundary from "./helpers/errorBoundary";
// import * as serviceWorker from "./serviceWorker";
//import { worker } from './mocks/browser'

/* if (process.env.NODE_ENV === 'development') {
    worker.start()
  } */

ReactDOM.render(
  <ErrorBoundary>
    <AppWrapper>
      <App />
    </AppWrapper>
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
